import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { DropZoneComponent } from './drop-zone.component';



@NgModule({
  declarations: [
    DropZoneComponent
  ],
  imports: [
    CommonModule,
    NgxDropzoneModule
  ],
  exports: [
    DropZoneComponent
  ]
})
export class DropZoneModule { }
